function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.831.688l1.754,3.7,3.592.381A.919.919,0,0,1,13.664,6.4L10.8,8.755l.886,3.959a.919.919,0,0,1-1.374.987L7,11.686,3.685,13.7a.92.92,0,0,1-1.375-.987L3.2,8.755.336,6.4A.919.919,0,0,1,.824,4.772l3.591-.381L6.169.688A.92.92,0,0,1,7.831.688Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/star.1cd85f6a.svg";
export { SvgComponent as ReactComponent };